module.exports = new __parcel__URL__("close_icon.e149c202.png").toString();